const GEMINI_API_URL = 'https://generativelanguage.googleapis.com/v1beta/models/gemini-2.5-flash:generateContent?key=AIzaSyBMXx-2HvTaWLTFJftsSnTbS3bZ7glPo8I';

interface AskGeminiResponse {
    diagnostico: string;
}

export async function askGemini(text: string): Promise<any> {
    const payload = {
        contents: [
            {
                parts: [
                    {
                        text,
                    },
                ],
            },
        ],
    };

    const response = await fetch(GEMINI_API_URL, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
    });

    const data = await response.json();

    // // Gemini's response structure may vary; adjust as needed
    const resultText = data?.candidates?.[0]?.content?.parts?.[0]?.text ?? '';

    let parsed = [];
    try {
        let jsonStart = resultText.indexOf('[');
        let jsonEnd = resultText.lastIndexOf(']');
        if (jsonStart !== -1 && jsonEnd !== -1) {
            const jsonString = resultText.substring(jsonStart, jsonEnd + 1);
            parsed = JSON.parse(jsonString);
        }
    } catch (error) {
        console.log({ error })
    }

    return parsed;
}